import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/caesar";
import { Search, CornerDownLeft } from "lucide-react";

const EXAMPLES = [
  "Show me everyone who owes us money",
  "What money could close this week?",
  "Which projects have no next action?",
  "Who do I need to call today?",
  "What are our biggest opportunities?",
];

export default function AskCaesar({ open, onOpenChange }) {
  const [q, setQ] = useState("");
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const ask = async (question) => {
    const query = (question || q).trim();
    if (!query) return;
    setQ(query); setLoading(true); setAnswer(""); setError("");
    try {
      const { data } = await api.post("/ask", { question: query });
      setAnswer(data.answer);
    } catch (e) {
      setError("SZR could not process that. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { onOpenChange(v); if (!v) { setAnswer(""); setError(""); } }}>
      <DialogContent className="bg-surface border-edge max-w-2xl" data-testid="ask-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl flex items-center gap-2">
            <span className="text-gold">Ask</span> SZR
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="flex items-center gap-2 bg-ink border border-edge rounded-lg px-3">
            <Search size={18} className="text-[#A3A3A3]" />
            <input
              data-testid="ask-input" autoFocus value={q}
              onChange={(e) => setQ(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && ask()}
              placeholder="Ask about your operation…"
              className="flex-1 bg-transparent h-12 outline-none text-[#FAFAFA] placeholder:text-[#5a5a5a]"
            />
            <button data-testid="ask-submit" onClick={() => ask()} className="text-gold"><CornerDownLeft size={18} /></button>
          </div>

          {!answer && !loading && !error && (
            <div className="flex flex-wrap gap-2">
              {EXAMPLES.map((ex) => (
                <button key={ex} data-testid="ask-example" onClick={() => ask(ex)}
                  className="text-xs px-3 py-1.5 rounded-full border border-edge text-[#A3A3A3] hover:text-[#FAFAFA] hover:border-gold/30 transition-colors">
                  {ex}
                </button>
              ))}
            </div>
          )}

          {loading && (
            <div className="flex items-center gap-3 text-[#A3A3A3] py-6">
              <span className="w-3 h-3 rounded-full bg-gold animate-pulse" /> SZR is analyzing the operation…
            </div>
          )}
          {error && <div className="text-sred text-sm">{error}</div>}
          {answer && (
            <div data-testid="ask-answer" className="bg-ink border border-edge rounded-lg p-4 text-sm leading-relaxed whitespace-pre-wrap max-h-[50vh] overflow-y-auto">
              {answer}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
